import * as React from "react";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { esES, enUS, frFR, deDE, ptBR } from "@mui/x-data-grid-pro";
import { InarixGridFilterModel } from "../../../redux/slices/dataTable/data";
import { TFunction } from "i18next";
export function FiltersDataTableObject(
  map: any,
  columnName: string,
  value: string[],
  operator: string,
) {
  if (value.length > 0)
    return {
      column: map[columnName] || columnName,
      operator: columnName === "cerealName" ? undefined : operator,
      value,
    };
  else {
    return undefined;
  }
}

export function addDays(date: any, days: number) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export default function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number },
) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

export function ManageErrorString(error: string) {
  if (error) {
    return true;
  } else {
    return false;
  }
}

export const goBackFunction = (
  navigate: any,
  t: (arg0: string) => string,
  titleGoBack: string,
  historyPushTo: string,
  titleGoBack2?: string,
) => {
  const goBackFunc = () => {
    navigate(historyPushTo);
  };

  return (
    <div className="arrow-back" onClick={() => goBackFunc()} aria-hidden>
      <ArrowBackIcon className="arrow-back-data-div" />
      {`${t(titleGoBack)}`}
      {titleGoBack2 ? `/${t(titleGoBack2)}` : ""}
    </div>
  );
};

export const changePosInArray = (arr: any[], from: any, to: any) => {
  arr.splice(to, 0, arr.splice(from, 1)[0]);
  return arr;
};

export const changePosInArrayMultiple = (
  arr: any[],
  moves: { from: number; to: number }[],
): any[] => {
  const result = [...arr];

  // Filter out moves where the element doesn't exist in the array (from === -1)
  const validMoves = moves.filter(({ from }) => from !== -1);

  // Snapshot the actual elements at the original indices before any mutation
  const movedElements = validMoves.map(({ from }) => arr[from]);

  for (let i = 0; i < validMoves.length; i++) {
    const element = movedElements[i];
    const to = validMoves[i].to;
    // Re-find the current position of the element in the (already mutated) result
    const currentFrom = result.indexOf(element);
    if (currentFrom === -1) continue;
    result.splice(to, 0, result.splice(currentFrom, 1)[0]);
  }

  return result;
};

export const getDataGridLocale = (locale) => {
  switch (locale) {
    case "pt":
      return ptBR.components.MuiDataGrid.defaultProps.localeText;
    case "es":
      return esES.components.MuiDataGrid.defaultProps.localeText;
    case "fr":
      return frFR.components.MuiDataGrid.defaultProps.localeText;
    case "de":
      return deDE.components.MuiDataGrid.defaultProps.localeText;
    case "en":
    default:
      return enUS.components.MuiDataGrid.defaultProps.localeText;
  }
};

export const managingFiltersText = (
  filterModel: InarixGridFilterModel,
  t: TFunction<"global", undefined>,
  rows: any[],
) => {
  if (filterModel.items.length > 0 && rows.length === 0) {
    return t("Data.no_results_filters");
  }
  return t("Data.no_results_data");
};
